import React, { useEffect, useState } from "react";
import EmploymentGapsForm from "./EmploymentGapsForm";
import { hasOnlySpaces } from "../../Helper/common";
import EmploymentGapFormContainer from "./EmploymentGapFormContainer";

const EmploymentGapFormWrapper = (props) => {

    const {
        gapData,
        closeGapPopUp,
        handleGapReasonSubmit,
        gapReasonKey,
        gapName,
      } = props;

      const len = Object.keys(gapData.responseArr || {}).length;
      const gapKey = len == 1 ? "Gap" : "Gaps";
      const [eduEmpGaps, setEduEmpGaps] = useState([]);
      const [empGaps, setEmpGaps] = useState([]);
      const [eduEmpGapsError, setEduEmpGapsError] = useState([])
      const [empGapError, setEmpGapError] = useState([]);
      const [numberOfGaps, setNumberOfGaps] = useState(0);

      useEffect(() => {
        if(gapData?.responseArr){
          let len = 0 
            if(gapData?.responseArr?.eduemp?.length) {
                console.log("eduempgap....", gapData?.responseArr?.eduemp)
                setEduEmpGaps(gapData?.responseArr?.eduemp);
                const eduEmpErr = new Array(gapData?.responseArr?.eduemp?.length).fill(
                  false
                );
                len += gapData?.responseArr?.eduemp?.length || 0
                setEduEmpGapsError(eduEmpErr);
            }
            if(gapData?.responseArr?.emp?.length) {
                console.log("empgap....", gapData?.responseArr?.emp)
                setEmpGaps(gapData?.responseArr?.emp)
                const empErr = new Array(gapData?.responseArr?.emp?.length).fill(
                  false
                );
                len += gapData?.responseArr?.emp?.length || 0
                setEmpGapError(empErr);
            }
            setNumberOfGaps(len);
        }
      },[gapData])

      const handleReason = (val, key, gapType) => {
        console.log("val...",val);
        console.log("key...",key);
        console.log("type...",gapType);
        if(gapType === "eduemp"){
          const tempEduEmpData = [...eduEmpGaps];
          const tempEduEmpError = [...eduEmpGapsError];
          tempEduEmpData[key].gap_reason = val;
          tempEduEmpError[key] = false;
          setEduEmpGaps(tempEduEmpData);
          setEduEmpGapsError(tempEduEmpError);
        }

        if(gapType === "emp"){
          const tempEmpData = [...empGaps];
          const tempEmpError = [...empGapError];
          tempEmpData[key].gap_reason = val;
          tempEmpError[key] = false;
          setEmpGaps(tempEmpData);
          setEmpGapError(tempEmpError);
        }
      };

       const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;
    let eduEmpErr = [...eduEmpGapsError];
    let empErr = [...empGapError];
    for (var i in eduEmpGaps) {
      if (eduEmpGaps[i].gap_reason == "" || eduEmpGaps[i].gap_reason == null) {
        eduEmpErr[i] = true;
        hasError = true;
      }
    }
    setEduEmpGapsError(eduEmpErr);
    for (var i in empGaps) {
      if (empGaps[i].gap_reason == "" || empGaps[i].gap_reason == null) {
        empErr[i] = true;
        hasError = true;
      }
    }
    setEmpGapError(empErr);
    if (!hasError) {
      handleGapReasonSubmit([...eduEmpGaps, ...empGaps]);
    } else {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }
  };

      useEffect(()=>{
        console.log("eduEmpdata...", eduEmpGaps);
        console.log("empGap...", empGaps)
      })
    return (
        <div>
              <h4 className="fnt-smi-bld auth-header mt-2">
        {numberOfGaps} {numberOfGaps > 1 ? `Gaps` : `Gap`} Found
      </h4>
      {
        eduEmpGaps?.map((gapDetails, index) => <EmploymentGapFormContainer 
        key={index+1} 
        sequence={index+1}
        index={index} 
        gapDetails={gapDetails} 
        gapType={"eduemp"}
        handleReason={handleReason}
        hasError = {eduEmpGapsError[index]}
        />)
      }
      {
        empGaps?.map((gapDetails, index) => <EmploymentGapFormContainer 
        key={eduEmpGaps?.length ? eduEmpGaps?.length + index + 1 : index + 1} 
        sequence={eduEmpGaps?.length ? eduEmpGaps?.length + index + 1 : index + 1} 
        index={index} 
        gapDetails={gapDetails} 
        gapType={"emp"}
        handleReason={handleReason}
        hasError = {empGapError[index]}
        />)
      }
       <div className="d-flex justify-content-start align-items-center my-5 pt-5">
        <button
          className="btn font-weight-bold btn-outline-secondary"
          onClick={(e) => {
            // Handle back functionality here if needed
            closeGapPopUp(e);
          }}
        >
          Back
        </button>
        <button
          className="btn font-weight-bold btn-primary ml-2"
          onClick={(e) => handleSubmit(e)}
        >
          Continue
        </button>
      </div>
        </div>
    )
} 

export default EmploymentGapFormWrapper;